import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URLS } from '../../../shared/constants/api-request.urls';

@Injectable({ providedIn: 'root' })
export class HoldersService {
  private http = inject(HttpClient);

  getHolders(stockId?: string, pageNumber?: number, pageSize?: number): Observable<any> {
    let params = new HttpParams();

    if (stockId) params = params.set('stockId', stockId);
    if (pageNumber) params = params.set('pageNumber', pageNumber.toString());
    if (pageSize) params = params.set('pageSize', pageSize.toString());

    return this.http.get(URLS.HOLDER, { params });
  }

  getHolderById(id: string): Observable<any> {
    return this.http.get(`${URLS.HOLDER}/${id}`);
  }

  createHolder(holder: any): Observable<any> {
    return this.http.post(URLS.HOLDER, holder);
  }

  updateHolder(id: string, holder: any): Observable<any> {
    return this.http.put(`${URLS.HOLDER}/${id}`, holder);
  }

  deleteHolder(id: string): Observable<any> {
    return this.http.delete(`${URLS.HOLDER}/${id}`);
  }
}
